import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/flights/AirlinesSection/AirlinesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/flights/HowWorksSection/HowWorksSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/flights/PlaceSection/PlaceSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/flights/PointsSection/PointsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/flights/SearchFlightsHero/SearchFlightsHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/flights/TestimonialsSection/TestimonialsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/common/CookieDialog/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/common/HotJar/HotJar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useSearchFocus","SearchFocusProvider"] */ "/app/src/app/context/Search/SearchFocusProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useSearchOfferData","SearchOfferDataProvider"] */ "/app/src/app/context/Search/SearchOfferDataContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/context/walletServiceContext/walletServiceContext.tsx");
